(() => {
  if (customElements.get('ormsby-logo-marquee')) return;

  class OrmsbyLogoMarquee extends HTMLElement {
    connectedCallback() {
      const speed = Number(this.dataset.speed) || 40;
      this.style.setProperty('--as-marquee-duration', `${speed}s`);

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        this.classList.add('is-paused');
        return;
      }

      this.addEventListener('mouseenter', () => this.classList.add('is-paused'));
      this.addEventListener('mouseleave', () => this.classList.remove('is-paused'));
      this.addEventListener('focusin', () => this.classList.add('is-paused'));
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.classList.remove('is-paused');
      });
    }
  }

  customElements.define('ormsby-logo-marquee', OrmsbyLogoMarquee);
})();
